/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {ApplicationState} from '@/types/redux';
import {NavState} from '../reducers/nav';

export type NavCTCAdminType = Omit<NavState, 'defaultPage' | 'previousPage' | 'isInternalRoute' | 'pageSecurityInitialized'>;
export type NavPagesSideSheetType = Omit<NavCTCAdminType, 'currentPage' | 'secondaryNav' | 'selectedIndex'>;
export type NavPageSelectionType = Omit<NavCTCAdminType, 'isUserProfileView' | 'pages' | 'sideSheet'>

export const selectPages             = ({nav: {pages}}: ApplicationState) => pages;
export const selectIndex             = ({nav: {selectedIndex}}: ApplicationState) => selectedIndex;
export const selectActiveIndex       = ({nav: {activeIndex}}: ApplicationState) => activeIndex;
export const selectCurrentPage       = ({nav: {currentPage}}: ApplicationState) => currentPage;
export const selectSecondaryNav      = ({nav: {secondaryNav}}: ApplicationState) => secondaryNav;
export const selectSidesheet         = ({nav: {sideSheet}}: ApplicationState) => sideSheet;
export const selectIsUserProfileView = ({nav: {isUserProfileView}}: ApplicationState) => isUserProfileView;
const selectNavCollapsedStatus       = ({nav}: ApplicationState) => nav.collapsed;

export const navSidesheetSelector = createDeepEqualSelector([
  selectIsUserProfileView,
  selectPages,
  selectSidesheet
],
(
  isUserProfileView,
  pages,
  sideSheet
): NavPagesSideSheetType => ({
  pages,
  sideSheet,
  isUserProfileView
}));

export const navSelectionSelector = createDeepEqualSelector([
  selectCurrentPage,
  selectSecondaryNav,
  selectIndex
],
(
  currentPage,
  secondaryNav,
  selectedIndex
): NavPageSelectionType => ({
  currentPage,
  selectedIndex,
  secondaryNav
}));

export const activeIndexSelector = createSelector(selectActiveIndex,
  (activeIndex: number): number => activeIndex
);

export const currentPageSelector = createSelector([selectCurrentPage], (currentPage) => (currentPage));

export const navCollapsedStatusSelector = createSelector(selectNavCollapsedStatus,
  (collapsed: boolean): boolean => collapsed
);
